"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4381],{

/***/ 66042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BreadcrumbComp; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44541);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25617);






var BreadcrumbComp = function(props) {
    var store_info = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.storeReducer.store;
    }).store_info;
    var homeClick = function() {
        next_router__WEBPACK_IMPORTED_MODULE_2___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_1__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_1__.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: "pointer category-breadcrumb ".concat((props === null || props === void 0 ? void 0 : props.classes) || "")
    }, props), {
        onClick: homeClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "mr2 relative",
                children: [
                    "Home",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "bottomborder"
                    })
                ]
            }),
            " ",
            "/"
        ]
    }));
};


/***/ }),

/***/ 84381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _CategoryHeaderBase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74809);
/* harmony import */ var _CategoryHeaderProductCount__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9868);
/* harmony import */ var _CategoryName__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37630);
/* harmony import */ var _Breadcrumb__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66042);
/* harmony import */ var _components_FilterAndSorting__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74794);






var CategoryHeader2 = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_CategoryHeaderBase__WEBPACK_IMPORTED_MODULE_1__/* .CategoryHeaderBase */ .m, {
        classes: "category-header-2 flex items-center justify-center flex-column !tw-z-[2]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center justify-center block-style",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Breadcrumb__WEBPACK_IMPORTED_MODULE_4__/* .BreadcrumbComp */ .Z, {
                        classes: "category-breadcrumb-2"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CategoryName__WEBPACK_IMPORTED_MODULE_3__/* .CategoryNameComp */ .l, {
                        classes: "category-name-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center justify-between w-100 relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CategoryHeaderProductCount__WEBPACK_IMPORTED_MODULE_2__/* .CategoryProductCount */ .Z, {
                        classes: "tc center product-count-2"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FilterAndSorting__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CategoryHeader2);


/***/ }),

/***/ 74809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ CategoryHeaderBase; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var CategoryHeaderBase = function(_param) {
    var children = _param.children, classes = _param.classes, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "classes"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "category-header ".concat(classes || "")
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 9868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CategoryProductCount; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25617);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13886);







var CategoryProductCount = function(_param) {
    var _classes = _param.classes, classes = _classes === void 0 ? "" : _classes, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "classes"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), count = ref[0], setCount = ref[1];
    var ref1 = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return {
            catalogData: state.catalogReducer
        };
    }), _catalogData = ref1.catalogData, categories = _catalogData.categories, catalog_items = _catalogData.catalog_items, productTags = _catalogData.productTags;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if ((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(productTags).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(categories)).length) {
            var ref, ref1;
            var catId = (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.category_id) || ((next_router__WEBPACK_IMPORTED_MODULE_1___default()) === null || (next_router__WEBPACK_IMPORTED_MODULE_1___default()) === void 0 ? void 0 : (ref1 = (next_router__WEBPACK_IMPORTED_MODULE_1___default().query)) === null || ref1 === void 0 ? void 0 : ref1.cid);
            if (catId) {
                var ref2, ref3;
                var specificCatalogItem = catalog_items[catId];
                setCount(specificCatalogItem === null || specificCatalogItem === void 0 ? void 0 : (ref2 = specificCatalogItem.filter) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.call(specificCatalogItem, function(item) {
                    return item.is_active === _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .ITEM_ACTIVE_STATUS.ACTIVE */ .p4.ACTIVE;
                })) === null || ref3 === void 0 ? void 0 : ref3.length);
            }
        }
    }, [
        categories,
        productTags,
        catalog_items
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ttc product-count ".concat(classes || ""),
        children: [
            count,
            " Product",
            count === 1 ? "" : "s"
        ]
    });
};


/***/ }),

/***/ 37630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ CategoryNameComp; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26706);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);






var CategoryNameComp = function(_param) {
    var _classes = _param.classes, classes = _classes === void 0 ? "" : _classes, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "classes"
    ]);
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), activeCategoryName = ref1[0], setActiveCategoryName = ref1[1];
    var ref2 = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_1__/* .useSSRSelector */ .kF)(function(state) {
        return {
            catalogData: state.catalogReducer
        };
    }), _catalogData = ref2.catalogData, categories = _catalogData.categories, productTags = _catalogData.productTags;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (categories.length > 0 || productTags.length > 0) {
            var ref, ref1;
            var allCategories = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(productTags || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(categories || []));
            var catId = (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.category_id) || (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.cid);
            if (catId) {
                var ref2;
                var activeCatIndex = allCategories.findIndex(function(el) {
                    return el.id === Number(catId);
                });
                setActiveCategoryName(((ref2 = allCategories[activeCatIndex]) === null || ref2 === void 0 ? void 0 : ref2.name) || "Available Items");
            }
        }
    }, [
        categories,
        productTags,
        router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "category-name ".concat(classes || ""),
        children: activeCategoryName
    });
};


/***/ }),

/***/ 74794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13886);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25617);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96031);
/**
 * This component will be responsible for handling filtering and sorting of a single category products
 */ 




var FilterAndSorting = function(props) {
    var setSelectedFilterInReducer = function setSelectedFilterInReducer(hideOutOfStock, sortOption) {
        var dataToSet = {
            is_hide_out_of_stock: hideOutOfStock,
            sort_option: sortOption
        };
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .setCatalogProductFilter */ .ls)(dataToSet));
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), selectedSortOption = ref1[0], setSelectedSortOption = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isHideOutOfStock = ref2[0], setIsHideOutOfStock = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openDropdown = ref3[0], setOpenDropdown = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var onFilterSelection = function(e, option) {
        e.stopPropagation();
        setOpenDropdown(false);
        setSelectedSortOption(option);
        setSelectedFilterInReducer(isHideOutOfStock, option);
    };
    var toggleHideOutOfStock = function(e) {
        e.stopPropagation();
        setIsHideOutOfStock(!isHideOutOfStock);
        setSelectedFilterInReducer(!isHideOutOfStock, selectedSortOption);
    };
    var dropdownClick = function() {
        setOpenDropdown(function(s) {
            return !s;
        });
    };
    var handleClickOutside = function(e) {
        if (ref.current && ref.current.contains(e.target)) {
            return;
        }
        setOpenDropdown(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "filter-sorting w-100 ".concat((props === null || props === void 0 ? void 0 : props.className) ? props.className : ""),
        ref: ref,
        onClick: dropdownClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "filter-sorting__box pointer flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "mv0",
                        children: [
                            "Sort: ",
                            (selectedSortOption === null || selectedSortOption === void 0 ? void 0 : selectedSortOption.displayText) || "Default Option"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "ml1",
                        alt: "dropdown button",
                        src: "/assets/images/down-arrow-thin.svg"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "filter-sorting__dropdown ".concat(openDropdown ? "active" : ""),
                children: [
                    _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .SORTING_OPTIONS.map */ .Hy.map(function(option, index) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "filter-sorting__dropdown--item pointer ".concat(option.id === (selectedSortOption === null || selectedSortOption === void 0 ? void 0 : selectedSortOption.id) ? "active" : ""),
                            onClick: function(e) {
                                return onFilterSelection(e, option);
                            },
                            children: option.displayText
                        }, index);
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                    _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .FILTER_OPTIONS.map */ .dl.map(function(filter, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "filter-sorting__dropdown__checkbox-container flex justify-between items-center pointer ".concat(isHideOutOfStock ? "active" : ""),
                            onClick: function(e) {
                                return toggleHideOutOfStock(e);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mv0",
                                    children: filter.displayText
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/assets/images/checkbox-filled.svg",
                                    className: isHideOutOfStock ? "dib" : "dn"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "checkbox-empty ".concat(isHideOutOfStock ? "dn" : "dib")
                                })
                            ]
                        }, index);
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FilterAndSorting);


/***/ })

}]);